import { render } from "./Codemirror.vue?vue&type=template&id=6c0d0c4a&bindings={\"modelValue\":\"props\",\"options\":\"props\",\"container\":\"setup\"}"
import script from "./Codemirror.vue?vue&type=script&lang=js"
export * from "./Codemirror.vue?vue&type=script&lang=js"
script.render = render

export default script